import { render, staticRenderFns } from "./MarginListSettings.vue?vue&type=template&id=1bfea000&scoped=true&"
import script from "./MarginListSettings.vue?vue&type=script&lang=js&"
export * from "./MarginListSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfea000",
  null
  
)

export default component.exports